import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Input,
  Tooltip,
  Whisper,
  Stack,
  IconButton,
  InputGroup,
  Form,
  Message,
  Table,
  SelectPicker,
  toaster
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import { Popconfirm } from 'antd';
import { ReviewPass } from '@rsuite/icons';

interface RowDataFinish {
  id: string; // or number, depending on your data
  attributes: {
    FinishCode: string;
    FinishName: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const FinishMaster = () => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  const data = ['Continue', 'Discontinue', 'All'].map(item => ({ label: item, value: item }));

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  ////////////////  Function For 4 Start /////////////////

  const [finish, setFinish] = useState({
    FinishCode: '',
    FinishName: '',
    dis: 'Continue'
  });
  // Fetch Data from API Start
  const [finishdata, setFinishdata] = useState<RowDataFinish[]>([]);
  const [finishmeta, setFinishmeta] = useState<MetaData>();
  const [disFinish, setDisFinish] = useState([]);
  const [editedRowIdsFinish, setEditedRowIdsFinish] = useState<string[]>([]);
  const [editedRowIdFinish, setEditedRowIdFinish] = useState<string>('');
  const [editedDataFinish, setEditedDataFinish] = useState<
    Record<string, Partial<RowDataFinish['attributes']>>
  >({});
  const [selectedBuyerfinish, setSelectedBuyerfinish] = useState('Continue');
  const handleBuyerChangefinish = value => {
    setSelectedBuyerfinish(value);
  };
  const [isLoading4, setIsLoading4] = React.useState(false);
  useEffect(() => {
    fetchData4();
  }, [selectedBuyerfinish]);
  const fetchData4 = async () => {
    if (isLoading4) {
      return;
    }
    setIsLoading4(true);
    let disFilter = '';
    if (selectedBuyerfinish.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyerfinish}`;
    }
    if (selectedBuyerfinish == 'All') {
      disFilter = '';
    }
    const pageResponse = await fetch(
      `${globalIP}/api/mstfinishes?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
    );
    const pageJson = await pageResponse.json();
    const allData = [];
    for (let page = 1; page <= pageJson.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mstfinishes?populate=*&pagination[page]=${page}&sort[0]=id${disFilter}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    const responseformeta = await fetch(
      `${globalIP}/api/mstfinishes?populate=*&publicationState=preview`
    );
    const jsonmeta = await responseformeta.json();
    const response2 = await fetch(`${globalIP}/api/mstfinishes`);
    const pageJson2 = await response2.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mstfinishes?populate=*&pagination[page]=${page}`
      );
      const pageJson2 = await pageResponse.json();
      allData2.push(...pageJson2.data);
    }
    setDisFinish(allData2);

    setFinishmeta(jsonmeta.meta);
    setFinishdata(allData);
    setIsLoading4(false);
  };

  const generateNextCategoryCode4 = () => {
    const nextCode = finishmeta?.pagination?.total + 1;
    return `FIN-${nextCode.toString().padStart(3, '0')}`;
  };
  const processInputRef = useRef(null);
  const handleEditRowFinish = rowData => {
    setFinish({ ...rowData.attributes })
    setEditedRowIdFinish(rowData.id);
    setEditedRowIdsFinish(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataFinish(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };
  const resetfinish = () => {
    setFinish({
      FinishCode: '',
      FinishName: '',
      dis: 'Continue'
    });
  };
  const handleCancelFinish = rowData => {
    resetfinish();
    setEditedRowIdFinish('');
    setEditedRowIdsFinish('');
  };
  let nextCategoryCode4 = generateNextCategoryCode4();
  const url4 = `${globalIP}/api/mstfinishes`;

  const submit4 = async e => {
    e.preventDefault();
    const trimmedFinishName = finish.FinishName?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;


    if (trimmedFinishName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.finish}.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (specialCharPattern.test(trimmedFinishName)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.finish} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        const { data: finishN } = await axios.get(
          `${globalIP}/api/mstfinishes?filters[FinishName][$eqi]=${trimmedFinishName}`
        );
        const { data: finishNcode } = await axios.get(`${globalIP}/api/mstfinishes?populate=*`);
        const nextCode = finishNcode.meta.pagination.total + 1;

        const existingFinish = disFinish.find(
          item => item.attributes.FinishName.toLowerCase() === trimmedFinishName.toLowerCase()
        );
        if (finishN.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              {label[0]?.attributes.finish} {trimmedFinishName} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          const nextCategoryCode = generateNextCategoryCode4();

          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              ...finish,
              FinishName: trimmedFinishName,
              FinishCode: `FIN-${nextCode.toString().padStart(3, '0')}`
            })
          );

          const response = await fetch(url4, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            await fetchData4();
            console.log(finish);

            toaster.push(
              <Message showIcon type="success">
                Data Saved Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error(error);
      }

      setFinish({
        FinishCode: '',
        FinishName: '',
        dis: 'Continue'
      });
    }
  };

  //  Fetch Data from API End
  const handleInputChange4 = (inputName, value, index) => {
    setFinish({ ...finish, [inputName]: value });
  };

  const handleFinC = async catalogId => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...finishdata,
        dis: 'Continue'
      })
    );
    fetch(`${globalIP}/api/mstfinishes/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData4();

        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleFinD = async catalogId => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...finishdata,
        dis: 'Discontinue'
      })
    );
    fetch(`${globalIP}/api/mstfinishes/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData4();

        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleSaveRowFinish = async (rowId: string) => {
    try {
      // const rowData = finishdata.find(row => row.id === rowId);
      if (!finish) {
        console.error('Row data not found.');
        return;
      }

      const updatedFinishName = finish?.FinishName?.trim() || '';
      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

      if (updatedFinishName === '') {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.finish}.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (specialCharPattern.test(updatedFinishName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.finish} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      const { data: updatefinishN } = await axios.get(
        `${globalIP}/api/mstfinishes?filters[FinishName][$eqi]=${updatedFinishName}&filters[id][$ne]=${editedRowIdFinish}`
      );

      if (updatefinishN.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.finish} {updatedFinishName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // const updatedRowData = {
      //   ...rowData,
      //   attributes: {
      //     ...rowData.attributes,
      //     ...editedDataFinish[rowId],
      //     FinishName: updatedFinishName
      //   }
      // };

      const response = await fetch(`${globalIP}/api/mstfinishes/${editedRowIdFinish}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { ...finish, FinishName: updatedFinishName } })
      });

      if (response.ok) {
        fetchData4();
        resetfinish('')
        setEditedRowIdFinish('')
        setEditedDataFinish(prevData => ({
          ...prevData,
          [editedRowIdFinish]: { ...finish, FinishName: updatedFinishName } // Ensure UI updates correctly
        }));
        setEditedRowIdsFinish(prevRowIds => [...new Set([...prevRowIds, editedRowIdFinish])]);
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };
  const handleSaveRowFinish1 = async (rowId: string) => {
    try {
      const rowData = finishdata.find(row => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }

      const updatedFinishName = editedDataFinish[rowId]?.FinishName?.trim();
      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;
      const { data: updatefinishN } = await axios.get(
        `${globalIP}/api/mstfinishes?filters[FinishName][$eqi]=${updatedFinishName}&filters[id][$ne]=${rowId}`
      );
      if (updatedFinishName === '') {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.finish}.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (specialCharPattern.test(updatedFinishName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.finish} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      const existingFinish = finishdata.find(
        item =>
          item.attributes.FinishName.toLowerCase() === updatedFinishName.toLowerCase() &&
          item.id !== rowId
      );

      if (updatefinishN.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.finish} {updatedFinishName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      const updatedRowData = {
        ...rowData,
        attributes: {
          ...rowData.attributes,
          ...editedDataFinish[rowId],
          FinishName: updatedFinishName
        }
      };

      const response = await fetch(`${globalIP}/api/mstfinishes/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: updatedRowData.attributes })
      });

      if (response.ok) {
        fetchData4();
        setEditedRowIdsFinish(prevRowIds => prevRowIds.filter(id => id !== rowId));
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeFinish = (rowId, fieldName, value) => {
    setEditedDataFinish(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...finishdata.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };
  ////////////////  Function For 4 End /////////////////
  ////////////////  Searching For 4 Start /////////////////
  const [searchQuery4, setSearchQuery4] = useState('');
  const [filterStatus4, setFilteredStatus4] = useState('Continue');
  const handleSearch4 = value => {
    setSearchQuery4(value);
  };
  const [finishfilterData, setFinishfilterData] = useState([]);
  useEffect(() => {
    const finishfilterData = finishdata
      .slice()
      .reverse()
      .filter(item => {
        const FinishName = item.attributes.FinishName
          ? item.attributes.FinishName.toLowerCase()
          : '';
        return FinishName.includes(searchQuery4.toLowerCase());
      });
    setFinishfilterData(finishfilterData);
  }, [finishdata, filterStatus4, searchQuery4]);
  ////////////////  Searching For 4 End /////////////////
  return (
    <>
      <Form.ControlLabel>
        <b>{label[0]?.attributes.finish}</b>
      </Form.ControlLabel>
      <Stack justifyContent="space-between" style={{ marginBottom: '10px' }} className="mstr-panel">
        <Stack spacing={160} className="mstr-panel1">
          <Input
            id="FinishName"
            name="FinishName"
            // style={{ width: '180%' }}
            autoComplete="off"
            ref={processInputRef}
            value={finish && finish.FinishName ? finish.FinishName : ''}
            onChange={value => handleInputChange4('FinishName', value, 0)}
            onPressEnter={submit4}
          />
          {editedRowIdFinish ? (
            <Button
              appearance="primary"
              color="cyan"
              onClick={handleSaveRowFinish}
              className="mstr-btn"
              style={{ marginLeft: '10px' }}
            >
              {' '}
              Update
            </Button>
          ) : (
            <Button
              appearance="primary"
              color="cyan"
              onClick={submit4}
              className="mstr-btn"
              style={{ marginLeft: '10px' }}
            >
              {' '}
              Add
            </Button>
          )}

        </Stack>
        <Stack className="mstr-search" spacing={5} style={{ marginLeft: '7px' }}>
          <SelectPicker
            data={data}
            placeholder="Status"
            labelKey="label"
            value={selectedBuyerfinish}
            onChange={handleBuyerChangefinish}
            searchable={false}
            valueKey="value"
            size="md"
            appearance="default"
            style={{ width: 130, marginLeft: '7px' }}
            cleanable={false}
          />
          <InputGroup inside>
            <Input placeholder="Search" type="text" value={searchQuery4} onChange={handleSearch4} />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </Stack>
      </Stack>
      <Table
        rowHeight={60}
        data={finishfilterData}
        height={tableHeight}
        rowKey="id"
        bordered
        cellBordered
        loading={isLoading4}
      >
        <Table.Column width={60} fixed>
          <Table.HeaderCell>
            <b>Sr. No.</b>
          </Table.HeaderCell>
          <Cell>{(_, rowIndex) => +rowIndex + 1}</Cell>
        </Table.Column>

        <Table.Column width={130} flexGrow={1}>
          <Table.HeaderCell>
            <b>{label[0]?.attributes.finish}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIdsFinish.includes(rowData.id) ? (
              //   <Input
              //     value={editedDataFinish[rowData.id]?.FinishName || ''}
              //     onChange={value => handleInputChangeFinish(rowData.id, 'FinishName', value)}
              //   />
              // ) : (
              rowData.attributes.FinishName
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIdsFinish.includes(rowData.id) ? (
                <div>
                  {/* <IconButton
                    size="sm"
                    icon={<CheckIcon />}
                    active
                    onClick={() => handleSaveRowFinish(rowData.id)}
                    style={{ marginRight: '10px' }}
                  /> */}
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowFinish(rowData)}
                    style={{ marginRight: '10px' }}
                  />
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    active
                    onClick={handleCancelFinish}
                  // onClick={() =>
                  //   setEditedRowIdsFinish(prevRowIds =>
                  //     prevRowIds.filter(id => id !== rowData.id)
                  //   )
                  // }
                  />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowFinish(rowData)}
                  />
                  {rowData.attributes.dis === 'Discontinue' ? (
                    <Popconfirm
                      title="Continue Finish"
                      description="Are you sure you want to continue this Finish?"
                      onConfirm={() => handleFinC(rowData.id)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Continue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<CheckRoundIcon />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleFinC(rowData.id)}
                        />
                      </Whisper>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Discontinue Finish"
                      description="Are you sure you want to discontinue this Finish?"
                      onConfirm={() => handleFinD(rowData.id)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Discontinue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<ReviewPass />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleFinD(rowData.id)}
                        />
                      </Whisper>
                    </Popconfirm>
                  )}
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
      <div>
        <p>
          <small>Total row:{finishfilterData.length}</small>
        </p>
      </div>
    </>
  );
};

export default FinishMaster;
